
<div class="holded-to-sage-container">
  <div class="header">
    <h1>Holded → Sage200 (2025)</h1>
    <p>Convierte archivos Excel de Holded al formato requerido por Sage200. Versión de 2025 con filtrado por tags y usuarios.</p>
  </div>

  <div class="content">
    <form class="upload-form" enctype="multipart/form-data">
  <div class="form-block">
    <label for="asientos">
      Fichero de asientos contables
      <span class="file-hint">(General Ledger)</span>
    </label>
    <input id="asientos" type="file" (change)="onFileChange($event, 'asientos')" accept=".xlsx" />
  </div>

  <div class="form-block">
    <label for="clientes">
      Fichero de clientes
      <span class="file-hint">(Contacts)</span>
    </label>
    <input id="clientes" type="file" (change)="onFileChange($event, 'clientes')" accept=".xlsx" />
  </div>

  <div class="form-block">
    <label for="plan">
      Fichero del plan contable
      <span class="file-hint">(Chart of Accounts)</span>
    </label>
    <input id="plan" type="file" (change)="onFileChange($event, 'plan')" accept=".xlsx" />
  </div>

  <div class="button-container">
    <button mat-raised-button
            color="primary"
            [disabled]="isLoading || (!asientosFile && !clientesFile && !planFile)"
            class="convert-button"
            (click)="convertFiles()"
    >
      <span class="button-content">
        <mat-spinner
          *ngIf="isLoading"
          diameter="16"
          strokeWidth="3"
          mode="indeterminate"
          color="accent"
          class="spinner-inline"
        />

        <span class="text-label">
          {{ isLoading ? 'Procesando...' : 'Convertir y descargar' }}
        </span>
      </span>
    </button>
  </div>
    </form>

    <!-- Registros rechazados: Clientes -->
    <div class="rejected-records-block" *ngIf="rejectedClientes.length > 0">
      <label>Clientes rechazados por falta de datos obligatorios</label>
      <div class="table-container">
        <table cellpadding="5" cellspacing="0" class="rejected-table">
          <thead>
            <tr>
              <th>Motivo</th>
              <th>Nombre</th>
              <th>Account</th>
              <th>ID</th>
              <th>Fecha Creación</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rejected of rejectedClientes">
              <td>{{ rejected.reason }}</td>
              <td>{{ getDisplayName(rejected.data['Name']) }}</td>
              <td>{{ rejected.data['Account'] || 'Sin Account' }}</td>
              <td>{{ rejected.data['ID'] || 'Sin ID' }}</td>
              <td>{{ formatExcelDate(rejected.data['Created']) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Registros rechazados: Asientos -->
    <div class="rejected-records-block" *ngIf="rejectedAsientos.length > 0">
      <label>Asientos rechazados por falta de datos obligatorios</label>
      <div class="table-container">
        <table cellpadding="5" cellspacing="0" class="rejected-table">
          <thead>
            <tr>
              <th>Motivo</th>
              <th>Descripción</th>
              <th>Fecha</th>
              <th>Account</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rejected of rejectedAsientos">
              <td>{{ rejected.reason }}</td>
              <td>{{ rejected.data['Description'] || 'Sin descripción' }}</td>
              <td>{{ formatExcelDate(rejected.data['Date']) }}</td>
              <td>{{ rejected.data['Account'] || 'Sin account' }}</td>
              <td>{{ rejected.data['Type'] || 'Sin tipo' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Estadísticas de asientos excluidos por filtros -->
    <div class="exclusion-stats-block" *ngIf="asientosExclusionStats && asientosExclusionStats.total > 0">
      <label>Asientos excluidos por filtros automáticos</label>
      <div class="stats-container">
        <div class="stat-row">
          <span class="stat-label">Total excluidos:</span>
          <span class="stat-value total">{{ asientosExclusionStats.total }}</span>
        </div>

        <div class="stats-divider"></div>

        <div class="stat-row" *ngIf="asientosExclusionStats.compraWithUUID > 0">
          <span class="stat-label">Compra + UUID:</span>
          <span class="stat-value">{{ asientosExclusionStats.compraWithUUID }}</span>
        </div>

        <div class="stat-row" *ngIf="asientosExclusionStats.startsWithUUID > 0">
          <span class="stat-label">Empieza con UUID:</span>
          <span class="stat-value">{{ asientosExclusionStats.startsWithUUID }}</span>
        </div>

        <div class="stat-row" *ngIf="asientosExclusionStats.tagsDevelop > 0">
          <span class="stat-label">Tags 'develop':</span>
          <span class="stat-value">{{ asientosExclusionStats.tagsDevelop }}</span>
        </div>

        <div class="stat-row" *ngIf="asientosExclusionStats.excludedDocumentIds > 0">
          <span class="stat-label">IDs excluidos (nombres / - DEV):</span>
          <span class="stat-value">{{ asientosExclusionStats.excludedDocumentIds }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
